import { render, staticRenderFns } from "./DelRole.vue?vue&type=template&id=46ceff4a"
import script from "./DelRole.vue?vue&type=script&lang=js"
export * from "./DelRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports